import React from "react";
import { useTranslation } from "react-i18next";
import loadable from "@loadable/component";
import PropTypes from "prop-types";
import { BLOCKS, DROPDOWN } from "./constants.js";
import VariantBlocks from "./layouts/VariantBlocks.js";

const layouts = {
    [BLOCKS]: VariantBlocks,
    [DROPDOWN]: loadable(() => import("./layouts/VariantDropdown.js")),
};

const VariantLayout = ({ variants, layout, ...props }) => {
    const { t } = useTranslation();
    const Component = layouts[layout];
    const priceFormatProps = {
        separateWith: " ",
        render: (price) => t("price_with_currency", { price }),
    };

    if (layout === DROPDOWN) {
        return <Component variants={variants} t={t} {...props} />;
    }

    return Object.values(variants).map((variant, index) => {
        return (
            <Component
                key={index}
                index={index}
                variant={variant}
                t={t}
                priceFormatProps={priceFormatProps}
                {...props}
            />
        );
    });
};

VariantLayout.propTypes = {
    layout: PropTypes.string.isRequired,
    variants: PropTypes.array.isRequired,
};

export default VariantLayout;
